module.exports = "<div class=\"header\">\r\n    <div>\r\n        <img src=\"../../assets/images/hvs-logo.png\" />\r\n    </div>\r\n</div>"